import getActiveSavedCart from './getActiveSavedCart';
import createSavedCart from './createSavedCart';

async function getOrCreateActiveSavedCart(){
  const activeSavedCart = await getActiveSavedCart();
  if(activeSavedCart){
    return activeSavedCart;
  }
  else {
    return await createSavedCart();
  }
}

export default getOrCreateActiveSavedCart;
